/* kware added new */

/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes, { object } from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import {
  NavList,
  NavListItem,
  Icon,
  DropdownMenu,
  Dropdown,
} from '@folio/stripes-components';
import { getLocaleLabel } from './LocalesServices';
import NavButton from '../../MainNav/NavButton';
import css from './styles.css';

const propTypes = {
  stripes: PropTypes.shape({
    setLocale: PropTypes.func,
    setDateformat: PropTypes.func,
    okapi: PropTypes.object,
    locale: PropTypes.string,
    userPreferredLocale: PropTypes.string,
    tenantDefaultLocale: PropTypes.string,
    userLocales: PropTypes.arrayOf(object),
    tenantLocales: PropTypes.arrayOf(object),
  }).isRequired,
};

const UserLocalesMenu = (props) => {
  const intl = useIntl();
  const locales = [
    {
      label: 'AR',
      value: 'ar',
    },
    {
      label: 'en-US',
      value: 'en-US',
    },
  ];
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const setLocale = (locale) => {
    if (locale) {
      props.stripes.setLocale(locale.value);
      toggleDropdown();
    }
  };

  const getDropdownContent = () => {
    return (
      <NavList>
        {locales.map((tl) => {
          return (
            <NavListItem
              key={tl.value}
              id={`clickable-locale-${tl.value}`}
              type="button"
              onClick={() => setLocale(tl)}
              disabled={tl.value === intl.locale}
              buttonStyle="primary"
            >
              {getLocaleLabel(tl.value, intl)}
            </NavListItem>
          );
        })}
      </NavList>
    );
  };

  const renderLocalesTrigger = ({ getTriggerProps, open }) => {
    const labelElement = (
      <Icon iconPosition="end" icon={open ? 'caret-up' : 'caret-down'}>
        {intl.locale.split('-')[0]}
      </Icon>
    );

    return (
      <NavButton
        label={labelElement}
        data-role="toggle"
        selected={open}
        icon={
          <div className={css.dropdownLabel}>
            <Icon icon="flag" />
          </div>
        }
        {...getTriggerProps()}
      />
    );
  };

  const renderLocalesMenu = ({ open }) => (
    <DropdownMenu open={open}>{getDropdownContent()}</DropdownMenu>
  );

  return (
    <div className={css.dropdownMenu}>
      <Dropdown
        id="userLanguageSwitcherDropdown"
        renderTrigger={renderLocalesTrigger}
        renderMenu={renderLocalesMenu}
        open={dropdownOpen}
        onToggle={toggleDropdown}
        placement="bottom-end"
        usePortal={false}
        relativePosition
        focusHandlers={{ open: () => false }}
      />
    </div>
  );
};

UserLocalesMenu.propTypes = propTypes;

export default UserLocalesMenu;
